import { render } from "./car-comparison-vertical-carousel-component.vue?vue&type=template&id=d8db55b4"
import script from "./car-comparison-vertical-carousel-component.vue?vue&type=script&lang=js"
export * from "./car-comparison-vertical-carousel-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__